// assets/infinitecollection.js
(() => {
  console.log('[infinite-collection] script loaded');

  const GRID_SELECTOR = '#product-grid';
  const SENTINEL_ID = 'infinite-scroll-sentinel';
  const LOAD_MORE_ID = 'InfiniteLoadMore';

  const state = {
    observer: null,
    spinner: null,
    loading: false,
    ended: false,
    nextPage: 2,
    sectionId: null,
    grid: null,
    sentinel: null,
    loadMoreBtn: null,
    initializing: false,
    lastUrl: '',
  };

  const currentURL = () => new URL(window.location.href);

  const buildPageUrl = (pageNumber) => {
    const u = currentURL();
    u.searchParams.set('page', String(pageNumber));
    u.searchParams.delete('section_id'); // Remove section_id if present
    return u;
  };

  const stripSectionParam = (u) =>
    u.replace(/([?&])section_id=[^&]+(&|$)/, '$1').replace(/[?&]$/, '');

  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  const getProductLisFromDoc = (doc) => {
    const ul = doc.querySelector('ul#product-grid');
    if (!ul) return [];
    return Array.from(ul.children).filter((el) => el.tagName === 'LI');
  };

  const stopInfinite = (reason = 'no more pages') => {
    state.ended = true;
    if (state.observer && typeof state.observer.disconnect === 'function') {
      state.observer.disconnect();
    }
    if (state.spinner) state.spinner.remove();
    if (state.loadMoreBtn) {
      state.loadMoreBtn.disabled = true;
      state.loadMoreBtn.hidden = true;
    }
    console.log('[infinite-collection] stopped:', reason);
  };

  const loadNextPage = async () => {
    if (state.loading || state.ended) return;
    state.loading = true;
    if (state.spinner) state.spinner.style.display = '';

    try {
      const pageUrl = buildPageUrl(state.nextPage);
      console.log('[infinite-collection] fetch →', pageUrl.toString());

      const res = await fetch(pageUrl.toString(), { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();
      const doc = parseHTML(html);

      // look for real products only: <li> children inside <ul id="product-grid">
      const ul = doc.querySelector('ul#product-grid');
      const lis = ul ? Array.from(ul.children).filter((el) => el.tagName === 'LI') : [];
      const added = lis.length;

      console.log('[infinite-collection] added items =', added);

      if (!added) {
        // No more products for the current filter/sort – stop silently
        stopInfinite('0 items returned');
        return;
      }

      lis.forEach((el) => state.grid.appendChild(el));

      // Update visible URL (no section_id), reflect the page we just appended
      const cleanUrl = stripSectionParam(pageUrl.toString());
      history.replaceState({ searchParams: pageUrl.search.slice(1) }, '', cleanUrl);

      state.nextPage += 1;
    } catch (err) {
      console.error('[infinite-collection]', err);
      stopInfinite('error');
    } finally {
      if (state.spinner) state.spinner.style.display = 'none';
      state.loading = false;
    }
  };

  const checkSentinelVisibility = () => {
    if (!state.sentinel || state.ended || state.loading) return;
    
    const rect = state.sentinel.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isVisible = rect.top <= windowHeight + 1200; // Match rootMargin
    
    console.log('[infinite-collection] Checking sentinel visibility:', {
      sentinelTop: rect.top,
      windowHeight,
      isVisible
    });
    
    // If sentinel is visible but observer hasn't triggered, manually load
    if (isVisible) {
      console.log('[infinite-collection] Sentinel visible, triggering load manually');
      loadNextPage();
    }
  };

  const teardown = () => {
    console.log('[infinite-collection] teardown called');
    if (state.observer && typeof state.observer.disconnect === 'function') {
      state.observer.disconnect();
    }
    state.observer = null;
    if (state.spinner) state.spinner.remove();
    state.spinner = null;
    state.sentinel = null;
    state.loadMoreBtn = null;
    state.grid = null;
    state.sectionId = null;
    state.loading = false;
    state.ended = false;
    state.nextPage = 2;
  };

  const init = () => {
    if (state.initializing) {
      console.log('[infinite-collection] already initializing, skipping');
      return;
    }
    state.initializing = true;

    console.log('[infinite-collection] ========== INIT START ==========');
    
    const currentUrlStr = window.location.href.split('#')[0];
    const urlChanged = state.lastUrl && state.lastUrl !== currentUrlStr;
    console.log('[infinite-collection] URL changed?', urlChanged);
    console.log('[infinite-collection] Current URL:', currentUrlStr);
    state.lastUrl = currentUrlStr;

    teardown();

    // Wait a bit for DOM to settle after facet updates
    setTimeout(() => {
      state.grid = document.querySelector(GRID_SELECTOR);
      if (!state.grid) {
        console.warn('[infinite-collection] #product-grid not found; aborting init');
        state.initializing = false;
        return;
      }

      state.sectionId =
        state.grid.getAttribute('data-id') ||
        document.querySelector('[data-section-id]')?.getAttribute('data-section-id') ||
        null;

      state.sentinel = document.getElementById(SENTINEL_ID);
      if (!state.sentinel) {
        console.warn('[infinite-collection] sentinel not found; aborting init');
        state.initializing = false;
        return;
      }

      state.loadMoreBtn = document.getElementById(LOAD_MORE_ID);
      if (state.loadMoreBtn) {
        const clone = state.loadMoreBtn.cloneNode(true);
        state.loadMoreBtn.replaceWith(clone);
        state.loadMoreBtn = document.getElementById(LOAD_MORE_ID);
        state.loadMoreBtn.hidden = true;
        state.loadMoreBtn.disabled = false;
        state.loadMoreBtn.addEventListener('click', loadNextPage, { passive: true });
      }

      const oldSpinner = document.querySelector('[data-infinite-spinner]');
      if (oldSpinner) oldSpinner.remove();

      state.spinner = document.createElement('div');
      state.spinner.setAttribute('data-infinite-spinner', 'true');
      state.spinner.textContent = 'Loading…';
      state.spinner.style.cssText = 'text-align:center;padding:16px;font-size:14px;display:none;';
      state.sentinel.insertAdjacentElement('afterend', state.spinner);

      const u = currentURL();
      const currentPage = Number(u.searchParams.get('page') || 1);
      state.nextPage = currentPage + 1;
      state.loading = false;
      state.ended = false;

      console.log('[infinite-collection] Current page from URL:', currentPage);
      console.log('[infinite-collection] Set nextPage to:', state.nextPage);
      console.log('[infinite-collection] Current filters:', u.search);

      if (state.observer) {
        state.observer.disconnect();
      }

      state.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            console.log('[infinite-collection] Sentinel intersecting?', e.isIntersecting);
            if (e.isIntersecting) loadNextPage();
          });
        },
        { rootMargin: '1200px 0px 1200px 0px' }
      );
      state.observer.observe(state.sentinel);

      console.log('[infinite-collection] ========== INIT COMPLETE ==========');
      console.log('[infinite-collection] nextPage=', state.nextPage, 'sectionId=', state.sectionId);
      
      // CRITICAL FIX: Check if sentinel is already visible after init
      // This handles cases where filters result in few products
      setTimeout(() => {
        checkSentinelVisibility();
      }, 250);
      
      state.initializing = false;
    }, 150); // Increased timeout to ensure facets have fully rendered
  };

  document.addEventListener('DOMContentLoaded', () => {
    console.log('[infinite-collection] DOMContentLoaded event fired');
    init();
  });

  document.addEventListener('facets:rendered', () => {
    console.log('[infinite-collection] facets:rendered event fired');
    setTimeout(init, 350); // Increased delay to ensure DOM is fully updated
  });
  
  document.addEventListener('facets:changed', () => {
    console.log('[infinite-collection] facets:changed event fired');
    setTimeout(init, 350);
  });
  
  document.addEventListener('shopify:section:load', () => {
    console.log('[infinite-collection] shopify:section:load event fired');
    setTimeout(init, 350);
  });

  // Also check on scroll in case observer fails
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      if (!state.loading && !state.ended && state.sentinel) {
        checkSentinelVisibility();
      }
    }, 100);
  }, { passive: true });

  window.addEventListener('popstate', () => {
    console.log('[infinite-collection] popstate event - reloading');
    window.location.reload();
  });
})();